import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function UserProtectedRoute() {
  const location = useLocation();
  
  // ✅ FIXED: Check for the ACTUAL keys your login page uses
  const userToken = localStorage.getItem("token") || localStorage.getItem("eraX_auth_token");
  const userEmail = localStorage.getItem("userEmail");
  
  console.log("🔒 UserProtectedRoute check:", {
    path: location.pathname,
    userToken: userToken ? "✓" : "✗",
    userEmail: userEmail ? "✓" : "✗"
  });
  
  // If no user token, redirect to user login
  if (!userToken) {
    console.log("⚠️ No user token - redirecting to user login");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // If has user token, allow access
  console.log("✅ User access granted");
  return <Outlet />;
}